const question = {
    bad: { point: [1] },
    average: { point: [2] },
    good: { point: [3] },
};
export default question;
